import { ChargingStation, Fireplace, LocalParking, Place } from "@mui/icons-material"
import { LocationTypeProps } from "../hooks/location/index.type"
import DoorIcon from "./RobotMap/_icons/door"
import LiftIcon from "./RobotMap/_icons/lift"
import { CSSProperties } from "react"
import { COLOR } from "../utils/colors"

export default function PinPointSelector({
  type,
  style
}: {
  type: LocationTypeProps,
  style?: CSSProperties
}) {
  switch (type as LocationTypeProps) {
    case 'door_point':
      return <DoorIcon style={{ fontSize: '16px', ...style }} />

    case 'lift_lobby_point':
    case 'lift_holding_point':
    case 'lift_point':
      return <LiftIcon style={{ fontSize: '16px', ...style }} />

    case 'charging_point':
      return <ChargingStation sx={{ color: 'green', ...style }} />

    case 'fire_alarm_point':
      return <Fireplace sx={{ color: 'orange', ...style }} />

    case 'parking_point':
      return <LocalParking sx={{ color: COLOR.accent.blue, ...style }} />
    // TODO: Need to add other case
    default:
      return <Place sx={{ color: 'red', ...style }} />
  }
}